export const manifest = {
  screens: {
    scr_n626tc: { name: "Home", route: "/#home", position: {"x":160,"y":220} },
    scr_knua22: { name: "Services", route: "/#services", position: {"x":1560,"y":220} },
    scr_z35ekl: { name: "About", route: "/#about", position: {"x":2960,"y":220} },
    scr_s9pmo6: { name: "Contact", route: "/#contact", position: {"x":4360,"y":220} },
    scr_4ewhsz: { name: "Boiler Installation", route: "/services/boiler-installation", position: {"x":160,"y":2200} },
    scr_hbqu0c: { name: "Boiler Repairs", route: "/services/boiler-repairs", position: {"x":1560,"y":2200} },
    scr_snc7pr: { name: "Central Heating Systems", route: "/services/central-heating-systems", position: {"x":2960,"y":2200} },
    scr_3sd4t5: { name: "Gas Safety Certificates", route: "/services/gas-safety-certificates", position: {"x":7160,"y":2200} },
    scr_zvpb4p: { name: "Emergency Callouts", route: "/services/emergency-callouts", position: {"x":4360,"y":2200} },
    scr_ketfbw: { name: "Gas Cooker Installation", route: "/services/gas-cooker-installation", position: {"x":5760,"y":2200} },
    scr_hxzx86: { name: "Power Flushing", route: "/services/power-flushing", position: {"x":8560,"y":2200} },
  },
  sections: {
    sec_ijzqic: { name: "Main Navigation", x: 0, y: 0, width: 5720, height: 1180 },
    sec_tzdo7r: { name: "Service Offerings", x: 0, y: 1980, width: 9920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ijzqic", children: [
      { kind: "screen", id: "scr_n626tc" },
      { kind: "screen", id: "scr_knua22" },
      { kind: "screen", id: "scr_z35ekl" },
      { kind: "screen", id: "scr_s9pmo6" },
    ] },
    { kind: "section", id: "sec_tzdo7r", children: [
      { kind: "screen", id: "scr_4ewhsz" },
      { kind: "screen", id: "scr_hbqu0c" },
      { kind: "screen", id: "scr_snc7pr" },
      { kind: "screen", id: "scr_zvpb4p" },
      { kind: "screen", id: "scr_ketfbw" },
      { kind: "screen", id: "scr_3sd4t5" },
      { kind: "screen", id: "scr_hxzx86" },
    ] },
  ],
}
